import React, {Component} from 'react'
import s from './ChipsList.module.css'

export interface IListForm {
  content: string
}

export interface IconTextListProps {
  list?: Array<IListForm>
}

const ChipsList: React.FC<IconTextListProps> = ((props) => {
  const {
    list,
  } = props

  return (
    <div className={s.root}>
      <div className={s.content}>
        <div className={s.inner}>
          <div className="">
            <ul className={s.list}>
              {list && list.map((item,index)=>{
                return <li className={s.chip} key={index}>
                  <p className={`${s.chipText}`}>{item.content}</p>
                </li>
              })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
})

export default ChipsList
